import React from 'react';
import ModelView from '../../components/modelview';
import request from 'superagent';
import config from '../../config';
import './index.css';

const API_URL = config.serverUrl;

export default class Intranet extends React.Component {

  downloadFile(file) {

    const url = `${API_URL}/asset/download/${file.id}`;

    request
      .get(url)
      .withCredentials()
      .end(function(err, resp) {
        if (err) {
          console.log('Error downloading file: ', err);
        }

        if (resp.statusCode === 302) {
          window.location = '/login';
          return;
        }

        let a = document.createElement("a");
        a.href = url;
        a.click();

      });
  }

  logout() {

    const url = `${API_URL}/logout`;

    request
      .get(url)
      .withCredentials()
      .end(function(err) {
        if (err) {
          console.log('Error logging out user: ', err);
        }

        window.location = '/login';

      });

  }

  render() {
    const modelViewProps = {
      fields: [
        { name: 'Name', property: 'name', type: 'text' },
        { name: 'Descriere', property: 'description', type: 'text' },
        { name: 'Size', property: 'size', type: 'text' }
      ],
      fieldActionButtons: [
        { name: 'Download', action: this.downloadFile.bind(this), style: { backgroundColor: '#3498db' } },
      ],
      model: 'asset',
      create: false,
      update: false,
      delete: false,
      query: {
        availability: 'intranet'
      }
    };

    return (
      <div className="viewsIntranet">
        <div>
          <button className="btn btn-info btn-logout" onClick={ this.logout.bind(this) }>Logout</button>
        </div>
        <h3 className="u-m-b-15">Intranet</h3>

        <div>
          <h6>Files</h6>
          <ModelView {...modelViewProps} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/intranet/index.js